import React from 'react'
import { useTranslation } from 'react-i18next'
import { ButtonProps } from '@node-space/storybook-components/dist/Button'
import { ModalActions, ModalBody, ModalNavBar } from '@node-space/storybook-components/dist/Modal'
import { Description } from 'components/Text'
import { IdVerificationLink } from './IdVerificationLink'

export type IdVerificationMessageProps = {
  contactType?: string
  contactFullName?: string
  linkUrl: string
  showMessage: boolean
  setShowMessage: React.Dispatch<React.SetStateAction<boolean>>
  onContinue?: (contactFullName: string) => void
}

export const IdVerificationMessage = ({
  contactType,
  contactFullName,
  linkUrl,
  setShowMessage,
  onContinue,
}: IdVerificationMessageProps) => {
  const { t } = useTranslation()

  const actions: ButtonProps[] = [
    {
      children: t('continue'),
      onClick: () => onContinue(contactFullName),
    },
  ]

  return (
    <>
      <ModalNavBar
        title={t('accountContact.createIdVerificationLink.title.anotherPerson', {
          contactFullName,
        })}
        onBack={() => setShowMessage(false)}
      />
      <ModalBody spaceChildren={24}>
        <Description>
          {t(`accountContact.createIdVerificationLink.requirements.${contactType}`)}{' '}
          {t(`accountContact.createIdVerificationLink.instructions.anotherPerson`)}
        </Description>
        <Description>{t('accountContact.createIdVerificationLink.convenientTime')}</Description>
        <IdVerificationLink url={linkUrl} />
      </ModalBody>
      <ModalActions actions={actions} />
    </>
  )
}
